import ApplianceCenter from 'App/Homeowner/ApplianceCenter';
import Documents from 'App/Homeowner/Documents';
import Finances from 'App/Homeowner/Finances';
import { translate } from 'App/Internationalization';
import React from 'react';
import paths from '../../../config/local/paths';
import PropertyScopedLayout from './PropertyScopedLayout';
import PropertyTeam from './PropertyTeam';
import ViewProperties from './ViewProperties';

/**
 * @param {{
 *  history: import('history').History,
 *  location: import('history').Location,
 *  match: { path: string, params?: { propertyId?: string } }
 * }} props
 * @returns {JSX.Element}
 */
export default function PropertyScopedPage(props) {
	const history = props.history;
	const location = props.location;
	const match = props.match;
	const routeComponentMap = {
		[paths.app.homeowner.properties.scoped.marketValuation]: (
			<Finances
				contentTitle={translate(
					'homeowner.pages.properties.scoped.submenu.market_valuation'
				)}
				history={history}
				location={location}
				match={match}
				mode="marketValuation"
			/>
		),
		[paths.app.homeowner.properties.scoped.finances]: (
			<Finances
				contentTitle={translate(
					'homeowner.pages.properties.scoped.submenu.finances'
				)}
				history={history}
				location={location}
				match={match}
				mode="finances"
			/>
		),
		[paths.app.homeowner.properties.scoped.documents]: (
			<Documents history={history} location={location} match={match} />
		),
		[paths.app.homeowner.properties.scoped.appliances]: (
			<ApplianceCenter
				history={history}
				location={location}
				match={match}
			/>
		),
		[paths.app.homeowner.properties.scoped.team]: (
			<PropertyTeam history={history} location={location} match={match} />
		),
	};
	const component = routeComponentMap[match.path] ?? (
		<ViewProperties history={history} location={location} match={match} />
	);

	return (
		<PropertyScopedLayout
			history={history}
			location={location}
			match={match}
		>
			{component}
		</PropertyScopedLayout>
	);
}
